export default "__VITE_ASSET__BWQluZV5__"